import LabelMapItem from "./LabelMapItem";

export default class LabelMap {
    constructor(arr) {
        /**
         *
         * @type {LabelMapItem[]}
         */
        this.items = [];

        for (let i = 0; i < arr.length; i++) {
            this.items.push(new LabelMapItem(arr[i]));
        }

        Object.freeze(this.items);
        Object.freeze(this);
    }

    /**
     *
     * @param value
     * @return {LabelMapItem | undefined}
     */
    get(value) {
        return this.items.find(item => value === item.value);
    }

    get values() {
        return this.items.map(item => item.value);
    }

    get labels() {
        return this.items.map(item => item.label);
    }

    get extras() {
        return this.items.map(item => item.extra);
    }

    toJSON() {
        return this.items;
    }
}
